import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { formatPrice } from '../../lib/utils';

export const TopClientsCard = ({ topClients }) => {
    if (!topClients?.length) return null;

    return (
        <Card className="mb-8 border-0 bg-white/80 backdrop-blur-sm shadow-sm rounded-2xl">
            <CardHeader>
                <CardTitle className="font-heading text-jungle">Top clients</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                    {topClients.map((client, idx) => (
                        <Card key={client._id} className="bg-jungle/5 border-0 rounded-xl">
                            <CardContent className="pt-4">
                                <div className="flex items-center gap-2 mb-2">
                                    <div className="w-8 h-8 rounded-full bg-leaf/20 flex items-center justify-center text-leaf font-bold text-sm">
                                        {idx + 1}
                                    </div>
                                    <span className="font-medium text-sm text-jungle truncate">{client.company}</span>
                                </div>
                                <p className="text-lg font-bold text-leaf">{formatPrice(client.total)}</p>
                                <p className="text-xs text-muted-foreground">{client.orders} commandes</p>
                            </CardContent>
                        </Card>
                    ))}
                </div>
            </CardContent>
        </Card>
    );
};
